class Filter {
    constructor() {
        this.node = null
        this.product = null
        this.type = null
        this.reason = null
    }

    static get fieldNames() {
        return {
            name: 'Nome',
            node: 'Árvore de Sortimento',
            product: 'Produto',
            type: 'Tipo do Pedido',
            reason: 'Motivo'
        }
    }

    static get fieldTypes() {
        return {
            name: 'text',
            node: 'number',
            product: 'text',
            type: 'text',
            reason: 'text'
        }
    }

    static get visibleFields() {
        return {
            id: true,
            name: true,
            node: true,
            product: true,
            type: true,
            reason: true
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            name: true,
            node: true,
            product: true,
            type: true,
            reason: true
        }
    }

    static get status() {
        return {
            status_all: {
                text: 'Todos',
                status: ''
            },

            status_active: {
                text: 'Em Análise',
                status: 'N'
            },

            status_inactive: {
                text: 'Pendente',
                status: 'P'
            },

            status_approved: {
                text: 'Aprovado',
                status: 'A'
            },

            status_reproved: {
                text: 'Reprovado',
                status: 'R'
            },

            status_concluded: {
                text: 'Concluído',
                status: 'C'
            }
        }
    }
}

export default Filter

export { Filter }
